import { LookerEmbedDashboard, LookerEmbedSDK } from "@looker/embed-sdk";
import { EmbedBuilder } from "@looker/embed-sdk/lib/embed_builder";

export const lookerHost = "regalvoicepbl.cloud.looker.com";

export function initLooker() {
    LookerEmbedSDK.init(lookerHost, "/looker/auth");
}

export function getLookerDashboardWithUrl(url: string): EmbedBuilder<LookerEmbedDashboard> {
    return LookerEmbedSDK.createDashboardWithUrl(url);
}
